import React from 'react'
import axios from 'axios';
import styled from 'styled-components'
import Dropdown from 'react-bootstrap/Dropdown';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

const NavBarContainer = styled.div`
  width: 100%;
  height: 8vh;
  background: #eff5f5;
  position: fixed;
  z-index: 1;
`;

const NavBarWrapper = styled.div`
  padding: 0 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const Left = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 768px) {
    margin-bottom: 10px;
  }
`;

const Logoheader = styled.span`
  font-weight: 500;
  font-size: 24px;
  margin-left: 10px;
  @media screen and (max-width: 768px) {
    font-size: 20px;
    margin-top: 10px;
    margin-left: 0;
  }
  @media screen and (max-width: 576px) {
    font-size: 18px;
  }
`;

const Logoheaders = styled.span`
  font-weight: 500;
  font-size: 24px;
  margin-left: 10px;
  @media screen and (max-width: 768px) {
    display: none;
  }
  @media screen and (max-width: 576px) {
    font-size: 18px;
  }
`;

const Center = styled.div``;

const Right = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const Avtar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-left: 20px;
  cursor: pointer;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const Logo = styled.img`
  width: 50px;
  height: 50px;
`;

const activeStyle = {
    textDecoration: "none",
    color: "#eee"
};

const InnerNavbar = ({ setIsLoggedIn }) => {

    const [TeacherData, setTeacherData] = useState([])
    const userName = localStorage.getItem('Username')
    const handleLogout = () => {
        setIsLoggedIn(false)
        localStorage.clear();
        window.location.href("/Login")
        window.location.reload();
    }

    console.log('userName', userName)
    useEffect(() => {
        axios({
            method: "get",
            url: `http://localhost:82/Bmu_backend/teacherprofile.php?Username=${userName}`,
            config: { headers: { "Content-Type": "multipart/form-data" } },
        })
            .then(function (response) {
                //handle success
                setTeacherData(response.data.data)
                console.log(response);
                // setSubmit("Submit");
            })
            .catch(function (response) {
                //handle error
                console.log(response);
            });
    }, [])

    return (
        <>
            <NavBarContainer>
                <NavBarWrapper>
                    <Left>
                        {/* <Logo src="/images/BMU_LOGO-removebg-preview.png" alt="logo" /> */}
                        <Logoheader>C.E.S</Logoheader>
                    </Left>
                    <Center>
                        <Logoheaders>Government Pleaders</Logoheaders>
                    </Center>
                    <Right>

                        <Dropdown>
                            <Dropdown.Toggle variant="#eff5f5" id="dropdown-basic">
                                <Avtar src={TeacherData.Gender === 'female'

                                    ? 'images/teacher1.jpg' // Female avatar image source
                                    // : 'https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava3.webp' // Default avatar image source
                                    : 'images/sir.png'
                                }
                                    alt="avatar" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item as={Link} to="/Profile">
                                    {TeacherData.Username}
                                </Dropdown.Item>
                                <Dropdown.Item as={Link} to="/Changepassword">
                                    Change Password
                                </Dropdown.Item>
                                <Dropdown.Item as={Link} to="/Login" onClick={handleLogout}>
                                    Logout
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </Right>
                </NavBarWrapper>
            </NavBarContainer>
        </>
    );
}

export default InnerNavbar